<div class="foco-header-row my-2">
  <p class="page-title m-0">Foco</p>
  <div class="form-field-container">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Mês</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [formControl]="selectedMonth"
        [min]="minDate"
        readonly
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker
          #picker
          startView="year"
          (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, picker)"
        ></mat-datepicker>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Código ANF</mat-label>
        <mat-select [(value)]="selectedAnf" (selectionChange)="getFoco()">
          @for (codigo of codigosAnf; track codigo) {
            <mat-option [value]="codigo">
              {{ codigo }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-tab-group class="foco-tabs">
    <mat-tab label="Tabela Foco">
      <div #divPrint class="d-flex flex-column align-items-center mt-1">
        <div class="foco-sub-header">
          <h5 class="foco-month-title">
            {{ selectedMonth.value | date : "MMMM yyyy" }}
          </h5>

          @if (!isPastMonth) {
            <div class="foco-filters">
              <p class="foco-filters-label">Filtrar por:</p>
              @for (tipo of tipos; track tipo) {
                <button
                  mat-button
                  class="foco-filter-btn"
                  (click)="openTipoModal(tipo)"
                  >
                  {{ tipo }}
                </button>
              }
            </div>
          }

          <div class="foco-actions">
            <button
              type="button"
              mat-mini-fab
              title="Exportar tabela para Excel"
              color="#fff"
            (click)="
              exportTableToExcel(
                'TabelaFoco' +
                  selectedMonth.value.getMonth() +
                  selectedMonth.value.getFullYear(),
                'Tabela Foco ' +
                  (selectedMonth.value.getMonth() + 1) +
                  '-' +
                  selectedMonth.value.getFullYear()
              )
            "
              class="foco-action-btn"
              >
              <mat-icon fontSet="material-symbols-outlined">table_view</mat-icon>
            </button>
            <button
              type="button"
              mat-mini-fab
              title="Descarregar PDF"
              color="#fff"
              (click)="downloadPDF(this.divPrint, 'portrait')"
              class="foco-action-btn"
              >
              <mat-icon fontSet="material-symbols-outlined">picture_as_pdf</mat-icon>
            </button>
            @if (!isPastMonth) {
              <button
                type="button"
                mat-mini-fab
                title="Adicionar Foco"
                class="foco-action-btn foco-action-btn-primary"
                (click)="openAddFocoDialog()"
                >
                <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
              </button>
            }
          </div>
        </div>

        <div class="col mt-1" style="width: 100%">
          @if (!isLoading) {
            <div
              class="container"
              style="max-width: 95vw; position: relative"
              >
              <div class="d-flex justify-content-start">
                <div class="foco-data-info-row">
                  @if (dadosAtualizadosA) {
                    <p class="foco-data-info foco-data-info--updated">
                      <mat-icon fontSet="material-symbols-outlined" class="foco-data-info-icon">update</mat-icon>
                      Dados atualizados a {{ dadosAtualizadosA | date:'dd-MM-yyyy' }}
                    </p>
                  }
                  @if (isCurrentMonth && dataSource && dataSource.data.length > 0) {
                    <p class="foco-data-info foco-data-info--lastSale">
                      <mat-icon fontSet="material-symbols-outlined" class="foco-data-info-icon">info</mat-icon>
                      {{ getFirstValidDate() }}
                    </p>
                  }
                </div>
              </div>
            </div>
          }
          @if (isLoading) {
            <div class="spinner-container">
              <mat-spinner></mat-spinner>
            </div>
          }
          <div class="focus-table-container d-flex justify-content-center mt-2 mb-4">
            <div class="table-scroll-container">
              @if (
                !isLoading && selectedMonth && dataSource.data.length > 0) {
                <table
              [id]="
                'TabelaFoco' +
                selectedMonth.value.getMonth() +
                selectedMonth.value.getFullYear()
              "
                  class="foco-table"
                  mat-table
                  [dataSource]="dataSource"
                  matSort
                  >
                  <!-- Produto Column -->
                  <ng-container matColumnDef="nome">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="nome-column"
                      >
                      Produto
                    </th>
                    <td mat-cell *matCellDef="let item" class="nome-column">
                      {{ item.produto.nome.toUpperCase() }}
                    </td>
                  </ng-container>
                  <!-- Info Column -->
                  <ng-container matColumnDef="info">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="info-column"
                      >
                      Info
                    </th>
                    <td mat-cell *matCellDef="let item" class="info-column">
                      @if (item.produto.detailing) {
                        <mat-icon
                          class="info-icon"
                          fontSet="material-symbols-outlined"
                          (click)="openDetailingPdf(item.produto.cod_produto)"
                          >description</mat-icon
                          >
                      }
                    </td>
                  </ng-container>
                  <!-- Tipo Column -->
                  <ng-container matColumnDef="tipo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="tipo-column"
                      >
                      Tipo
                    </th>
                    <td mat-cell *matCellDef="let item" class="tipo-column">
                      {{ item.tipo }}
                    </td>
                  </ng-container>
                  <!-- Código Column -->
                  <ng-container matColumnDef="cod_produto">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="codigo-column"
                      >
                      Código
                    </th>
                    <td mat-cell *matCellDef="let item" class="codigo-column">
                      {{ item.produto.cod_produto }}
                    </td>
                  </ng-container>
                  <!-- Edit Column -->
                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef class="edit-column">
                      Editar
                    </th>
                    <td mat-cell *matCellDef="let item" class="edit-column">
                      @if (item.editavel && !item.isBeingEdited) {
                        <mat-icon
                          class="cursor-pointer"
                          aria-hidden="false"
                          aria-label="edit icon"
                          fontSet="material-symbols-outlined"
                          (click)="item.isBeingEdited = true"
                          >edit</mat-icon
                          >
                        }
                        @if (item.isBeingEdited) {
                          <mat-icon
                            class="cursor-pointer"
                            aria-hidden="false"
                            aria-label="save icon"
                            fontSet="material-symbols-outlined"
                            (click)="updateFoco(item); item.isBeingEdited = false"
                            >save</mat-icon
                            >
                          }
                        </td>
                      </ng-container>
                      <!-- Objetivo Column -->
                      <ng-container matColumnDef="focoInt">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header
                          class="objetivo-column"
                          >
                          Objetivo
                        </th>
                        <td mat-cell *matCellDef="let item" class="objetivo-column">
                          @if (
                            item.editavel &&
                            !isPastMonth &&
                            item.isBeingEdited) {
                            <input
                              type="number"
                              [(ngModel)]="item.focoInt"
                              class="input-bottom-outline centered-input"
                      (keydown.enter)="
                        updateFoco(item); item.isBeingEdited = false
                      "
                              />
                            } @else {
                              {{ item.focoInt }}
                            }
                          </td>
                        </ng-container>
                        <!-- vendas Column-->
                        <ng-container matColumnDef="vendas">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="vendas-column"
                            >
                            Vendas
                          </th>
                          <td mat-cell *matCellDef="let item" class="vendas-column">
                            {{ item.vendas || 0 }}
                          </td>
                        </ng-container>
                        <!-- Stock Column-->
                        <ng-container matColumnDef="stock">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="stock-column"
                            >
                            Stock
                          </th>
                          <td mat-cell *matCellDef="let item" class="stock-column">
                            {{ item.stock || 0 }}
                          </td>
                        </ng-container>
                        <!-- ExpectedSalesPerDay Column -->
                        <ng-container matColumnDef="expectedSalesPerDay">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="expectedSalesPerDay-column"
                            >
                            Expected Sales Per Day
                          </th>
                          <td
                            mat-cell
                            *matCellDef="let item"
                            class="expectedSalesPerDay-column"
                            >
                            {{ item.expectedSalesPerDay || 0 }}
                          </td>
                        </ng-container>
                        <!-- ExpectedSalesToDate Column -->
                        <ng-container matColumnDef="expectedSalesToDate">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="expectedSalesToDate-column"
                            >
                            Expected Sales To Date
                          </th>
                          <td
                            mat-cell
                            *matCellDef="let item"
                            class="expectedSalesToDate-column"
                            >
                            {{ item.expectedSalesToDate || 0 }}
                          </td>
                        </ng-container>
                        <!-- Pace Column -->
                        <ng-container matColumnDef="pace">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="pace-column"
                            >
                            Pace
                          </th>
                          <td mat-cell *matCellDef="let item" class="pace-column">
                            {{ item.pace || 0 }}
                          </td>
                        </ng-container>
                        <!-- EmFalta Column -->
                        <ng-container matColumnDef="emfalta">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="emfalta-column"
                            >
                            Em Falta
                          </th>
                          <td mat-cell *matCellDef="let item" class="emfalta-column">
                            {{
                            item.focoInt - item.vendas > 0
                            ? item.focoInt - item.vendas
                            : 0
                            }}
                          </td>
                        </ng-container>
                        <!-- Progresso Column -->
                        <ng-container matColumnDef="progress">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="progresso-column"
                            >
                            Progresso
                          </th>
                          <td mat-cell *matCellDef="let item" class="progresso-column">
                            <ngb-progressbar
                              class="full-width-progressbar rounded-progressbar"
                              [type]="getProgressBarType(item.pace)"
                              [value]="item.progress || 0"
                              [showValue]="true"
                            ></ngb-progressbar>
                          </td>
                        </ng-container>
                        <!-- Estado Column
                        <ng-container matColumnDef="estado">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="estado-column"
                            >
                            Estado
                          </th>
                          <td
                            class="estado-column"
                            mat-cell
                            *matCellDef="let item"
                            class="estado-column"
                            >
                            @if (item.editavel && accessLevel == 1) {
                              @if (item.editavel) {
                                <mat-slide-toggle
                                  class="toggle-button"
                                  [checked]="item.status"
                                  (change)="onToggle(item)"
                                  [matTooltip]="
                                    !item.status
                                      ? 'Adiciona o produto ao foco'
                                      : 'Remove o produto do foco'
                                  "
                                >
                                  {{ !item.status ? "Inativo" : "Ativo" }}
                                </mat-slide-toggle>
                              }
                            } @else {
                              {{ item.status ? "Ativo" : "Inativo" }}
                            }
                          </td>
                        </ng-container> -->
                        <!-- Delete Column -->
                        <ng-container matColumnDef="delete">
                          <th mat-header-cell *matHeaderCellDef class="delete-column"></th>
                          <td mat-cell *matCellDef="let item" class="delete-column">
                            @if (
                              item.editavel &&
                              item.tipo === 'Farmácia'
                              ) {
                              <button
                                mat-icon-button
                                style="color: #999"
                    (click)="
                      item.tipo === 'Farmácia'
                        ? deleteFocoItem(item)
                        : onToggle(item)
                    "
                                >
                                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                              </button>
                            }
                          </td>
                        </ng-container>
                        <!-- Atualizado Column -->
                        <ng-container matColumnDef="atualizado">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="atualizado-column"
                            >
                            Última atualização:
                          </th>
                          <td mat-cell *matCellDef="let item" class="atualizado-column">
                            {{ item.data_Modificado | date : "dd/MM/yyyy" }}
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr
                          mat-row
                          *matRowDef="let row; columns: displayedColumns"
                          [ngClass]="{ 'disabled-row': !row.status }"
                        ></tr>
                      </table>
                    } @else {
                      @if (!isLoading) {
                        <div class="no-data-message">
                          Não existem dados para o período selecionado.
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>

            <!--     <div class="d-flex justify-content-end my-4" style="width: 95%">
            <button
              type="button"
              mat-fab
              title="Exportar tabela para Excel"
              color="#fff"
              (click)="
                exportTableToExcel(
                  'TabelaFoco' +
                    selectedMonth.value.getMonth() +
                    selectedMonth.value.getFullYear(),
                  'TabelaFoco' +
                    selectedMonth.value.getMonth() +
                    selectedMonth.value.getFullYear()
                )
              "
              class="ms-2"
            >
              <mat-icon fontSet="material-icons">table_view</mat-icon>
            </button>
            <button
              type="button"
              mat-fab
              title="Descarregar PDF"
              color="#fff"
              (click)="downloadPDF(this.divPrint)"
              class="ms-2"
            >
              <mat-icon fontSet="material-icons">picture_as_pdf</mat-icon>
            </button>
            @if (!isPastMonth && accessLevel == 1) {
              <button
                type="button"
                mat-fab
                title="Adicionar Foco"
                class="mx-2"
                color="primary"
                (click)="openAddFocoDialog()"
              >
                <mat-icon fontSet="material-icons">add_circle</mat-icon>
              </button>
            }
          </div> -->
        </mat-tab>

        @if (isPastMonth || isCurrentMonth) {
          <mat-tab label="Estatísticas">
            <div id="absoluteSalesChart" #divPrintStats class="stats-page">
              @if (isLoading) {
                <div class="spinner-container">
                  <mat-spinner></mat-spinner>
                </div>
              }

              <!-- Header row -->
              <div class="stats-header">
                <h5 class="foco-month-title" style="text-transform: capitalize">
                  Estatísticas - Foco de {{ selectedMonth.value | date : "MMMM yyyy" }}
                </h5>
                @if (isGeneratingStatsPdf) {
                  <mat-spinner diameter="28"></mat-spinner>
                } @else {
                  <button
                    type="button"
                    mat-mini-fab
                    title="Descarregar PDF"
                    color="#fff"
                    class="foco-action-btn"
                    (click)="exportChartToPDF()"
                    >
                    <mat-icon fontSet="material-symbols-outlined">picture_as_pdf</mat-icon>
                  </button>
                }
              </div>

              <!-- Stats cards row -->
              <div class="stats-cards-row">
                <div class="stats-card">
                  <span class="stats-card-value">{{ focoItem.length }}</span>
                  <span class="stats-card-label">Produtos em foco</span>
                </div>
                <div class="stats-card">
                  <span class="stats-card-value">{{ totalvendas }} / {{ totalFocoInt }}</span>
                  <span class="stats-card-label">Vendidos ({{ totalProgress | number : "1.0-0" }}%)</span>
                </div>
                <div class="stats-card">
                  <span class="stats-card-value">{{ numProducts100Progress }} / {{ focoItem.length }}</span>
                  <span class="stats-card-label">Produtos a 100%</span>
                </div>
              </div>

              <!-- Chart -->
              <div class="stats-chart-container">
                <h6 class="stats-chart-title">Vendas por Produto</h6>
                <div class="stats-chart-wrapper">
                  <canvas
                    baseChart
                    [datasets]="chartDataAbsolute"
                    [labels]="productNames"
                    [options]="absoluteBarChartOptions"
                    [type]="'bar'"
                    >
                  </canvas>
                </div>
              </div>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
